import router from '@/router/index'
import { ElMessageBox } from 'element-plus'

let handle = null
function showDialog (msg) {
    if (handle === null) {
        handle = ElMessageBox.prompt(msg, '提示', {
            closeOnClickModal: false,
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            type: 'warning',
            showInput: false
        }).then(() => {
            router.replace('/login')
        }).finally(() => {
            handle = null
        })
    }
}

export default {
    showDialog
}
